import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Grid, Table, TableBody } from '@material-ui/core'
import globalStyles from '@src/routes/Configurators/utils/styles'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

const useStyles = makeStyles((theme: Theme) => ({
  validationError: {
    color: theme.palette.warning.main,
    fontSize: theme.typography.pxToRem(13),
    marginTop: theme.spacing(2),
    textAlign: 'left',
  },
  validationWarningsTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    verticalAlign: 'top',
    paddingRight: theme.spacing(3),
  },
  tableBorder: {
    display: 'block',
  },
  redesignWarning: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(12),
    position: 'relative',
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  fullWidth: {
    width: '100%',
  },
}))

interface ValidationWarningsProps {
  warnings?: string[]
  redesign?: boolean
  fullWidth?: boolean
}

const ValidationWarnings: React.FC<ValidationWarningsProps> = ({
  warnings,
  redesign = false,
  fullWidth = false,
}) => {
  const classes = useStyles()
  const GlobalCSS = globalStyles()
  if (!warnings || warnings.length === 0) {
    return null
  }

  let WarningsMessage: any = ''

  if (warnings.length !== 0) {
    WarningsMessage = (
      <Grid
        className={`${GlobalCSS.validationWarningBorder} ${fullWidth ? classes.fullWidth : ''}`}
      >
        {warnings.map((err, index) => (
          <div key={index}>
            <div key={err}>
              <Table>
                <TableBody className={GlobalCSS.tableBorder}>
                  <tr>
                    <td className={GlobalCSS.validationWarningsTitle}>
                      <WarningRoundedIcon className={GlobalCSS.warningIcon} />
                    </td>
                    <td
                      className={
                        redesign
                          ? classes.redesignWarning
                          : GlobalCSS.validationWarningsMessage
                      }
                    >
                      {err}
                    </td>
                  </tr>
                </TableBody>
              </Table>
            </div>
          </div>
        ))}
      </Grid>
    )
  }
  return (
    <div
      className={`${classes.validationError} ${fullWidth ? classes.fullWidth : ''} `}
    >
      {WarningsMessage}
    </div>
  )
}

export default ValidationWarnings
